import { CatsRecordTypeEnum } from '@shared-enums/cats.enum';

import { ITableConfigEntity } from '../interfaces/internal-interfaces';
import { CatsRecord } from '../scripts/catsRecord';
import { ProductionEquipment } from './productionEquipment';
import { getConfigByKey } from './table-configs/table-config-helpers';

export class ProductionEquipmentCatsRecord extends CatsRecord {
  constructor(
    public readonly parent: ProductionEquipment,
    config: ITableConfigEntity[],
  ) {
    super('peq');
    this.__config = config;
    this.__RecOrderChanged$.subscribe({
      next: (number) => {
        const configByKey = getConfigByKey(this.__config ?? [], 'Zmatnr');
        if (configByKey) {
          configByKey.selectOptions = parent.datahub.contracts.findContractByServiceOrder(number)?.getEquipmentBillCodes() ?? [];
        }
      },
      error: (err) => {
        console.error('Error occurred while updating RecOrder:', err);
      },
    });
  }

  public getRequiredObject(productionEquipment: ProductionEquipment): this {
    this.Zmatnr = productionEquipment.BillCode;
    this.Employeenumber = productionEquipment.getPlaceholderEmployee();
    this.Quantity = 0;
    this.Workdate = productionEquipment.focusedDay?.unix ?? null;
    this.RecOrder = '';
    this.Statkeyfig = productionEquipment.SKF;
    this.ZempCreatedBy = productionEquipment.datahub.user.getEmpId();
    this.Zrecordtype = CatsRecordTypeEnum.ProductionEquipment;
    return this;
  }
}
